import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20elegant%20cozy%20living%20room%20with%20soft%20natural%20light%20streaming%20through%20sheer%20curtains%2C%20fresh%20flowers%20on%20a%20wooden%20table%2C%20a%20cup%20of%20tea%2C%20pale%20cream%20and%20blush%20pink%20tones%2C%20minimalist%20aesthetic%2C%20artistic%20photography%20with%20dreamy%20atmosphere%2C%20soft%20focus%20background%2C%20feminine%20and%20gentle%20mood&width=1800&height=900&seq=hero-wife-guide-2026&orientation=landscape"
        alt="第一次的人妻 - 温暖优雅的新婚生活指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <p className="text-white/80 text-sm md:text-base tracking-widest mb-4 md:mb-6 font-label uppercase">
            第一次成为妻子，你准备好了吗？
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-4 md:mb-6">
            第一次的<span className="text-primary-300">人妻</span>
          </h1>
          <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-8 md:mb-10">
            专为初为人妻的女性打造的温暖生活指南，<br className="hidden sm:block" />
            陪你从容度过角色转变，经营幸福的婚姻生活
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/newlywed-guide"
              className="px-7 py-3 bg-primary-500 text-white rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始阅读指南
            </Link>
            <Link
              to="/about"
              className="px-7 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full font-medium text-sm md:text-base hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}